<template>
  <pro-list-frame
    ref="plTable"
    :title="($t($route.name))"
    icon="mdi-cash-minus"
    :total="totalItems"
    :rows="items.length"
    :search.sync="search"
    :columns="toggleableHeaders"
    :hidden="hiddenColumns"
    :selected-count="selected.length"
    :loading="loading"
    :cell-sel="cellSel"
    :fixed="!mobileShow"
    :create-label="$t(typeForm)"
    @refresh="getItems"
    @filter="filter = true"
    @print="printStudio = true"
    @create="goTo(typeForm)"
    @toggle-column="toggleColumn"
    @show-all-columns="hiddenColumns = []"
    @cell-down="onCellDown"
    @cell-over="onCellOver"
    @clear-cells="clearCellSel"
    @clear-selection="selected = []"
  >
    <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <v-list-item
            v-if="lockPermission && selected.length > 0"
            link
            @click="lockGroup('lock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('lock')" />
          </v-list-item>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
          
        </v-list>
      </v-menu>
    </template>
    <template #kpis>
      <div class="pl-kpi pl-kpi--blue">
        <span class="pl-kpi__icon"><v-icon size="17">mdi-chart-bar</v-icon></span>
        <div class="pl-kpi__body">
          <span class="pl-kpi__label">{{ $t("totalSum") }}</span>
          <span class="pl-kpi__value pl-num">{{ faNum($numberFormat(summary ? summary.amount : 0)) }}</span>
        </div>
      </div>
      <div class="pl-kpi pl-kpi--amber">
        <span class="pl-kpi__icon"><v-icon size="17">mdi-percent</v-icon></span>
        <div class="pl-kpi__body">
          <span class="pl-kpi__label">{{ $t("sumTax") }}</span>
          <span class="pl-kpi__value pl-num">{{ faNum($numberFormat(summary ? summary.tax : 0)) }}</span>
        </div>
      </div>
      <div class="pl-kpi pl-kpi--green">
        <span class="pl-kpi__icon"><v-icon size="17">mdi-wallet</v-icon></span>
        <div class="pl-kpi__body">
          <span class="pl-kpi__label">{{ $t("sumCosts") }}</span>
          <span class="pl-kpi__value pl-num">{{ faNum($numberFormat(summary ? summary.price : 0)) }}</span>
        </div>
      </div>
      <div class="pl-kpi pl-kpi--rose">
        <span class="pl-kpi__icon"><v-icon size="17">mdi-tag</v-icon></span>
        <div class="pl-kpi__body">
          <span class="pl-kpi__label">{{ $t("sumDiscount") }}</span>
          <span class="pl-kpi__value pl-num">{{ faNum($numberFormat(summary ? summary.discount : 0)) }}</span>
        </div>
      </div>
    </template>
    <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
    </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-model="selected"
        v-column-resize="costListColumnPlugins"
        v-column-drag="costListColumnPlugins"
        v-column-pin="costListColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :loading="false"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        :footer-props="plFooterProps"
      >
        <template v-if="isMobile" v-slot:item="{ item, index }">
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-red': item.type == 'cost' ? true : false,
                  'mobile-td-list-border-green': item.type == 'income' ? true : false,
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          link
                          :disabled="item.lock ? true : false"
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item link @click="print('invoiceIncomePrint', item)">
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('print')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="
                            'https://abr.abriron.com/pi/' +
                            item.uid +
                            '?' +
                            'cuid=' +
                            cuid
                          "
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <log
                          :title-prop="$t('history')"
                          icon-prop="mdi-history"
                          :listProp="true"
                          :type-prop="typeForm"
                          :refIdProp="item.id"
                          mode-prop="button"
                        />
                        <v-list-item
                          v-show="removePermission(typeForm)"
                          link
                          :disabled="item.lock ? true : false"
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.account ? item.account.name : "" }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("account") }} : {{ item.customer ? item.account.name : "" }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("tax") }} : {{ $numberFormat(parseFloat(item.tax)) }}
                    {{ item.currency ? item.currency.name : "" }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("date") }} : {{ item.date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-if="item.refund && parseFloat(item.refund) > 0"
                        class="mx-0 me-1"
                        color="red"
                        small
                        outlined
                      >
                        {{ $numberFormat(parseFloat(item.refund)) }}
                        <v-icon> mdi-credit-card-refund-outline </v-icon>
                      </v-chip>
                      <v-chip
                        v-if="item.customer_id && !item.bank_id"
                        class="mx-0"
                        :color="item.remain > 0 ? 'red' : 'green'"
                        small
                        outlined
                      >
                        {{
                          item.remain > 0
                            ? $t("remainPrice") +
                              " " +
                              $numberFormat(parseFloat(item.remain))
                            : $t("payed")
                        }}
                      </v-chip>
                      <v-chip
                        v-if="item.bank_id"
                        class="mx-0"
                        color="green"
                        small
                        outlined
                      >
                        {{ $t("payed") }}
                      </v-chip>
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn dark text small color="primary" @click="edit(item)">
                    {{ $numberFormat(parseFloat(item.price)) }}
                    {{ item.currency ? item.currency.name : "" }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  class="pl-action-cell__btn"
                  v-bind="attrs"
                  icon
                  x-small
                  v-on="on"
                >
                  <v-icon small> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>

              <v-list dense>
              <v-list-item link :disabled="item.lock ? true : false" @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="lockPermission"
                link
                @click="lock(item, item.lock ? 'unlock' : 'lock')"
              >
                <v-list-item-icon>
                  <v-icon :color="item.lock ? 'green' : 'pink'">{{
                    item.lock ? "mdi-lock-open-outline" : "mdi-lock-outline"
                  }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.lock ? $t('unlock') : $t('lock')" />
              </v-list-item>
              <v-list-item
                v-show="type === 'income'"
                link
                @click="print('invoiceIncomePrint', item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="
                  'https://abr.abriron.com/pi/' + item.uid + '?' + 'cuid=' + cuid
                "
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-show="removePermission(typeForm)"
                link
                :disabled="item.lock ? true : false"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
              </v-list>
            </v-menu>
            <span class="pl-action-cell__row">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.price="{ item }">
          <a @click="edit(item)">
            {{
              $numberFormat(
                parseFloat(item.price),
                item.currency ? item.currency.decimal : 0
              )
            }}
            {{ item.currency ? item.currency.name : "" }}
            <v-chip
              v-if="item.refund && parseFloat(item.refund) > 0"
              class="mx-0 me-1"
              color="red"
              small
              outlined
            >
              {{ $numberFormat(parseFloat(item.refund)) }}
              <v-icon> mdi-credit-card-refund-outline </v-icon>
            </v-chip>
            <v-chip
              v-if="item.customer_id && !item.bank_id"
              class="mx-0"
              :color="item.remain > 0 ? 'red' : 'green'"
              small
              outlined
            >
              {{
                item.remain > 0
                  ? $t("remainPrice") + " " + $numberFormat(parseFloat(item.remain))
                  : $t("payed")
              }}
            </v-chip>
            <v-chip v-if="item.bank_id" class="mx-0" color="green" small outlined>
              {{ $t("payed") }}
            </v-chip>
          </a>
        </template>
        <template v-slot:item.tax="{ item }">
          <a @click="edit(item)">
            {{
              $numberFormat(
                parseFloat(item.tax),
                item.currency ? item.currency.decimal : 0
              )
            }}
            {{ item.currency ? item.currency.name : "" }}
          </a>
        </template>
        <template v-slot:item.discount="{ item }">
          <a @click="edit(item)">
            {{
              $numberFormat(
                parseFloat(item.discount),
                item.currency ? item.currency.decimal : 0
              )
            }}
            {{ item.currency ? item.currency.name : "" }}
          </a>
        </template>
        <template v-slot:item.title="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                :color="item.last_status.status.color"
                text
                v-on="on"
                @click="edit(item)"
              >
                {{ item.title }}
              </v-btn>
            </template>
            <span>{{ $t("edit") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
          <v-icon v-if="item.lock" color="red" style="font-size: 22px">
            mdi-lock-outline
          </v-icon>
        </template>
        <template v-slot:item.sub_type="{ item }">
          {{ item.sub_type ? $t(item.sub_type) : "" }}
        </template>
        <template v-slot:item.plan="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.plan"
              color="primary"
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ item.plan.plan.name }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.ref_name="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.ref_name"
              label
              outlined
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="relationLink(item)"
            >
              {{ item.ref_name }}
            </v-chip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-if="item.ref_item_name"
                  label
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  small
                  color="primary"
                  style="margin-left: 1px; margin-right: 1px; max-width: 100px"
                  class="px-1 mb-1"
                >
                  {{ $t("product") }} {{ item.ref_item_name }}
                </v-chip>
              </template>
              <span>{{ item.ref_item_name }}</span>
            </v-tooltip>
            <div class="pt-1">
              <v-chip
                v-for="(integrate, index) in item.integrator"
                :key="index"
                color="green"
                label
                small
                style="margin-left: 1px; margin-right: 1px"
                class="px-1 mb-1"
              >
                <span class="px-1 white--text">
                  {{ $t(integrate.key) }} | {{ $t("id") }} : {{ integrate.value }}
                  {{
                    integrate.number ? " | " + $t("number") + ":" + integrate.number : ""
                  }}
                </span>
              </v-chip>
            </div>
          </div>
        </template>
        <template v-slot:body.append>
          <tr v-if="isMobile || mobileShow">
            <td :colspan="`${isMobile ? 6 : Number(showHeaders.length)}`">
              <div style="width: 100%" class="pa-1">
                <strong>{{ $t("sumInPage") }}</strong> :
                <v-chip color="primary" class="px-1">
                  <span class="px-1 white--text">
                    {{ $numberFormat(totals.sum) }}
                  </span>
                </v-chip>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t("sumInPage") }}</span>
            <span
              class="app-list-page-totals__item app-list-page-totals__item--final"
            >
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sum) }}
                {{ $store.state.currency.name }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />
  </pro-list-frame>
</template>

<script>
export default {
  name: "CostListDesktopView",
};
</script>
